import Vue from 'vue'
import Vuex from 'vuex'
import Cookies from 'js-cookie'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: Cookies.get('admin_token') || '',
    userInfo: JSON.parse(localStorage.getItem('admin_userInfo') || '{}')
  },
  mutations: {
    SET_TOKEN(state, token) {
      state.token = token
      Cookies.set('admin_token', token, { expires: 7 })
    },
    SET_USER_INFO(state, userInfo) {
      state.userInfo = userInfo
      localStorage.setItem('admin_userInfo', JSON.stringify(userInfo))
    },
    CLEAR_USER(state) {
      state.token = ''
      state.userInfo = {}
      Cookies.remove('admin_token')
      localStorage.removeItem('admin_userInfo')
    }
  },
  actions: {
    login({ commit }, { token, userInfo }) {
      commit('SET_TOKEN', token)
      commit('SET_USER_INFO', userInfo)
    },
    logout({ commit }) {
      commit('CLEAR_USER')
    }
  },
  getters: {
    token: state => state.token,
    userInfo: state => state.userInfo,
    isPlatformAdmin: state => state.userInfo.role === 1,
    isScenicAdmin: state => state.userInfo.role === 2,
    isStaff: state => state.userInfo.role === 3
  }
})
